import {
  DeliveriesIcon,
  ProductsIcon,
  AppointmentIcon,
  ConfirmIcon,
} from '../svg';

export const tabs = [
  {
    icon: ProductsIcon,
    title: 'PRODUCTS',
  },
  {
    icon: DeliveriesIcon,
    title: 'DELIVERIES',
  },
  {
    icon: AppointmentIcon,
    title: 'APPOINTMENTS',
  },
  {
    icon: ConfirmIcon,
    title: 'CONFIRMED',
  },
];

export const ERROR_MESSAGE = '504 (Gateway Timeout)';
export const TITLE = 'We are loading your order';
export const INFO_MESSAGE = 'We’re just checking your order details and will show them shortly';
export const MAX_LOADING_TIME = 90000;
